export default __webpack_public_path__ + "0a9322f1f66a338ec4e86e5a9da7009d.png";